module.exports = __webpack_public_path__ + "img/RedteaSIM_06.2d180990.jpg";